/* @flow */
import type { ReduxState, Action, Fetchable, FindFeaturedParams, Featured } from 'types';
// ===========================
//   STATE TYPE
// ===========================
export type FeaturedState = {
  params: FindFeaturedParams,
  featured: Fetchable<Featured[]>,
  pageScroll: number,
};

const initialPageScroll = 0;

// ===========================
//   INITIAL STATE
// ===========================
export const initialState: FeaturedState = {
  params: {},
  featured: { fetching: false },
  pageScroll: initialPageScroll,
};

const isStaleRequest = (params?: FindFeaturedParams, requestParams: FindFeaturedParams) => {
  return false;
  // return !(
  //   params &&
  //   isEqual({ ...params, pagination: undefined }, { ...requestParams, pagination: undefined })
  // );
};

// ===========================
//   REDUCER
// ===========================
export default (state: FeaturedState = initialState, action: Action): FeaturedState => {
  switch (action.type) {
    case 'FETCH_FEATURED_LIST_REQUEST': {
      return {
        ...state,
        featured: { fetching: true },
      };
    }
    case 'FETCH_FEATURED_LIST_SUCCESS': {
      if (!isStaleRequest(state.params, action.meta.initialPayload)) {
        // const categoryIds = keys(action.payload).map(parseInt);
        const data = action.payload;
        return {
          ...state,
          featured: { data, fetching: false },
          pageScroll: initialPageScroll,
        };
      } else {
        // ignore results
        return state;
      }
    }
    case 'FETCH_FEATURED_LIST_FAILURE': {
      if (!isStaleRequest(state.params, action.meta.initialPayload)) {
        const error = action.payload;
        return {
          ...state,
          featured: { error, fetching: false },
          pageScroll: initialPageScroll,
        };
      } else {
        // ignore results
        return state;
      }
    }
    case 'FEATURED_SCROLL_PAGE': {
      const pageScroll = action.payload || 0;
      return {
        ...state,
        pageScroll,
      };
    }
    case 'LOGOUT_SUCCESS':
      return initialState;

    default: {
      return state;
    }
  }
};

// ===========================
//   SELECTORS
// ===========================

export const getFindFeaturedParams = (state: ReduxState): FindFeaturedParams => {
  return state.featured.params;
};

export const getFeatured = (state: ReduxState): Fetchable<Featured[]> => {
  return state.featured.featured;
};
